import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * On every route change, scroll the window to the top.
 * Mounted once inside <BrowserRouter> so it sees every pathname change.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname]);
  return null;
}
